import { useSearchParams } from "react-router-dom"
import { Tabs } from "@chakra-ui/react"
import Selection from "@hydrologiq/shared/selection/Selection"
import { SectionRoot } from "@hydrologiq/shared/chakra/custom/Section"
import { useGetCopyHomeRoute } from "@hydrologiq/shared/providers/helpers/useCopy"
import { useUserRole } from "@hydrologiq/shared/providers/helpers/useUserRole"
import { DataConnectorsTab } from "@hydrologiq/shared/data-connectors/DataConnectorsTab"
import { DataConnectionsTab } from "../components/DataConnectionsTab"

// The second tab is "Monitoring Instances", not "Data Connections": next to "Data Connectors" the two
// labels are one word apart and easy to misread. Both are glossary terms (CONTEXT.md), and each row is
// a Monitoring Instance, matching the id shown in its expanded diagnostics.
export const CONNECTIONS_TABS = ["data-connectors", "monitoring-instances"] as const
type ConnectionsTab = (typeof CONNECTIONS_TABS)[number]

function ConnectionsView() {
  const [searchParams, setSearchParams] = useSearchParams()
  const tabParam = searchParams.get("tab")
  const activeTab: ConnectionsTab = CONNECTIONS_TABS.includes(tabParam as ConnectionsTab)
    ? (tabParam as ConnectionsTab)
    : "data-connectors"
  const { name, path } = useGetCopyHomeRoute()
  const isPlatformAdmin = useUserRole() === "admin"

  return (
    <Selection sectionHeading={name ?? "Connections"} sectionBase={path ?? "connections"} parents={[]} subNavItems={[]}>
      <SectionRoot>
        <Tabs.Root
          value={activeTab}
          variant={"sectionLozenge" as any}
          onValueChange={(details) => setSearchParams({ tab: details.value }, { replace: true })}
        >
          <Tabs.List>
            <Tabs.Trigger value="data-connectors">Data Connectors</Tabs.Trigger>
            <Tabs.Trigger value="monitoring-instances">Monitoring Instances</Tabs.Trigger>
          </Tabs.List>
          <Tabs.Content value="data-connectors">
            <DataConnectorsTab isPlatformAdmin={isPlatformAdmin} />
          </Tabs.Content>
          <Tabs.Content value="monitoring-instances">
            <DataConnectionsTab />
          </Tabs.Content>
        </Tabs.Root>
      </SectionRoot>
    </Selection>
  )
}

export default ConnectionsView
